<template>
  <el-container class="SerialSelectPrint">
    <el-main class="p-0">
      <div class="of-auto" style="height: 180px">
        <div ref="serial">
          <BarcodeSerial 
            v-for="(item, index) in items"
            :key="index"
            :config="config.control" 
            :data="item"
          />
        </div>
      </div>
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        v-shortkey="['f8']"
        @shortkey.native="handleClickPrint"
        @click="handleClickPrint"
      >인 쇄 (F8)</el-button>
      <el-button @click="handleClockClose" class="right">{{$t('button.close')}} (Esc)</el-button>
    </el-footer>
  </el-container>
</template>
<script>
import Vue from 'vue'
import { mapGetters } from "vuex";
import BarcodeSerial from '@/spa/Common/BarcodeSerial'
import Print from '@/plugins/print/print'

Vue.use(Print);

export default {
  name: "SerialSelectPrint",
  components: {BarcodeSerial},
  data() {
    return {
      title: this.$t('title.serial_print'),
      config: {},
    };
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters(["table_config"]),
  },
  created() {
    this.loadConfig();
  },
  mounted() {
    this.$nextTick(() => this.loadData());
  },
  methods: {  
    loadConfig() {
      let item = this.table_config.find(c => c.key === 'print');
      if (!item) { return; }
      this.util.copyObject(item.value, this.config);
    },
    handleClickPrint() {
      this.$print(this.$refs.serial);
    },
    handleClockClose() {
      this.$emit('completed');
    },
  }
};
</script>